import Vue from 'vue'
import App from './App.vue'
import router from "./router/index";
import "@/permission"; // permission control

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

// Vue.prototype.$basePreviewUrl = 'http://120.25.174.94:9000/water-io';
// Vue.prototype.$basePreviewUrl = 'https://www.hewie.online/resources/water-io';
Vue.prototype.$basePreviewUrl = 'https://www.ddss.org.cn/resources/ddss-io';

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
